<template>
	<article
		:id="`card-${structure.id}`"
		:class="{ card: true, 'card--selected': isSelected }"
		@click="emits('select-structure', structure.id)"
	>
		<div class="header">
			<!-- Nom de la structure -->
			<h3
				class="font-weight-bold"
				style="margin: 0"
			>
				{{ structure.name }}
			</h3>

			<!-- Distance -->
			<span style="margin-left: 15px;">
				{{ structure.address.distance }}&nbsp;km
			</span>
		</div>

		<v-divider style="margin: 15px 0" />

		<!-- Adresse -->
		<IconText
			:icon="mdiMapMarker"
			:text="getFormattedStructureAddress()"
			icon-color="yellow"
		/>

		<!-- Bouton de consultation des fiches contact-->
		<ContactCard
			v-if="structure.contact_card_list.length > 0"
			:structure-contact-list="structure.contact_card_list"
		/>

		<!-- Bouton de consultation des radiologues -->
		<RadiologueCard
			v-if="structure.professional_list.length > 0"
			:structure-professional-list="structure.professional_list"
		/>

		<!-- Accessibilité aux personnes en fauteuils roulants -->
		<IconText
			v-if="isDisabledPeopleAdapted"
			:icon="mdiWheelchairAccessibility "
			text="Avec accès handicapés"
			icon-color="yellow"
		/>

		<!-- Mammographes adaptés -->
		<IconText
			v-if="isAdaptedMammography"
			:icon="mdiWheelchair"
			icon-color="yellow"
			text="Avec mammographe adapté"
		/>
	</article>
</template>

<script setup lang="ts">
	import { VDivider } from 'vuetify/lib';
	import { mdiWheelchairAccessibility, mdiWheelchair, mdiMapMarker } from '@mdi/js';
	import { computed } from 'vue';

	import IconText from './card-content/icon-text.vue';
	import ContactCard from './card-content/contact-card.vue';
	import RadiologueCard from './card-content/radiologue-card.vue';
	import { Structure } from '@/types/structure';
	import { DISABLED_PEOPLE_ADAPTED_FEATURE_ID, IS_ADAPTED_MAMMOGRAPH_FEATURE_ID } from '@/constants/features';

	const props = defineProps<{
		structure: Structure;
		isSelected: boolean;
	}>();

	const emits = defineEmits<{
		(e: 'select-structure', structureId: number): void;
	}>();

	function getFormattedStructureAddress(): string {
		return  `${props.structure.address.label} ${props.structure.address.postal_code} ${props.structure.address.city}`;
	}

	const isDisabledPeopleAdapted = computed(() =>
		props.structure.feature_list.find(f => f.feature_id === DISABLED_PEOPLE_ADAPTED_FEATURE_ID)?.value === 'true');

	const isAdaptedMammography = computed(() =>
		props.structure.feature_list.find(f => f.feature_id === IS_ADAPTED_MAMMOGRAPH_FEATURE_ID)?.value === 'true');
</script>

<style lang="css" scoped>
.card {
	cursor: pointer;
	border: 1px solid #eeeeee;
	display: flex;
	gap: 0.2rem;
	flex-direction: column;
	padding: 1rem;
	width: 100%;
	border-bottom: 4px solid #0c419a;
	scroll-snap-align: start;
}

.card:hover {
	background-color: #e8f1ff;
}

.card--selected {
	background-color: #e8f1ff;
	border: 2px solid #0c419a;
}

@media screen and (max-width: 768px) {
	.card {
		scroll-snap-align: center;
		flex: 0 0 60%;
		height: auto;
		max-height: 400px;
		overflow: auto;
	}
}

.header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
}
</style>
